import * as React from 'react';
import { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import ArHistoryPayment from '../models/arHistoryPayment';
import { useArServiceCtx } from '../AccountsReceivableServiceContext';

interface IArHistoryPaymentHistoryDialogProps {
    dialogName: string;
    hideDialog: () => void;
    entryNumber?: number;
}

const formatDateForDisplay = (value: Date | string): string => {
    if (!value) {
        return '';
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
        return '';
    }
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${month}/${day}/${date.getFullYear()}`;
};

const formatCurrency = (value: number) =>
    (value ?? 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

// Mirrors the Payments popup (AR_DETAIL_TRANS block, opened by double-clicking an invoice row -
// oid 114). OK button (oid 262: Go_Block('Ar_Detail'); Hide_Window('W_Payments')) just closes it.
const ArHistoryPaymentHistoryDialog = (props: IArHistoryPaymentHistoryDialogProps) => {
    const { getArHistoryPayments } = useArServiceCtx();
    const [payments, setPayments] = useState<Array<ArHistoryPayment>>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!props.entryNumber) {
            setPayments([]);
            return;
        }
        setLoading(true);
        getArHistoryPayments(props.entryNumber).then((result) => {
            setPayments(Array.isArray(result) ? result : []);
            setLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.entryNumber]);

    return (
        <Dialog title="Payment History" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '45%' }}>
            <table style={{ width: '100%' }}>
                <thead style={{ textAlign: 'center' }}>
                    <tr>
                        <th>Payment Date</th>
                        <th>Check No.</th>
                        <th>Amount</th>
                        <th>Invoice</th>
                        <th>Deposit Date</th>
                        <th>No.</th>
                    </tr>
                </thead>
                <tbody>
                    {loading && (
                        <tr>
                            <td colSpan={6} className="bold-centered">
                                <LoadingSpinner />
                            </td>
                        </tr>
                    )}
                    {!loading && payments.map((payment, index) => (
                        <tr key={`${payment.checkNo}-${index}`} style={{ textAlign: 'center' }}>
                            <td>{formatDateForDisplay(payment.paymentDate)}</td>
                            <td>{payment.checkNo}</td>
                            <td style={{ textAlign: 'right' }}>{formatCurrency(payment.amount)}</td>
                            <td>{payment.invoiceNo}</td>
                            <td>{formatDateForDisplay(payment.depositDate)}</td>
                            <td>{payment.depositNo}</td>
                        </tr>
                    ))}
                    {!loading && payments.length === 0 && (
                        <tr><td colSpan={6} className="bold-centered">No Payments Found</td></tr>
                    )}
                </tbody>
            </table>
            <div className="form-row" style={{ marginTop: '1rem', justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ width: '25%' }} text="OK" onClick={() => props.hideDialog()} />
            </div>
        </Dialog>
    );
};

export default ArHistoryPaymentHistoryDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/dialogs/ArHistoryPaymentHistoryDialog.tsx